import { Icon, IconProps } from './Icon';

export const UpcomingDayIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 40 40"
  >
    <circle
      cx="20"
      cy="20"
      r="17.5772"
      fill="#DEE3EB"
    />
  </Icon>
);
